import { MapLatLng } from './map.latlng';
import { MapPolyline } from './map.polyline';

export class MapPolylinePoint {
    public id: number;            // Identificador secuencial
    public dataModel: any;        // Objeto asociado (modelo de negocio)
    public content: string;       // Contenido que aparece cuando se picha sobre el punto
    public polyline?: MapPolyline; // Polilina que lo contiene
    public point: MapLatLng;
    // Agregados
    public clickPoint?: MapLatLng; // Punto sobre el que se ha pinchado en el mapa

    constructor(id: number, content: string, point: MapLatLng) {
        this.id = id;
        this.content = content;
        this.point = point;
    }

    setData(data: any) {
        this.dataModel = (data !== undefined ? data : null);
    }
}
